import React from 'react';
import AppIcon from './AppIcon';

const icons = {
    '/': 'dashboard', '/obras': 'building', '/trabalhadores': 'users',
    '/recursos-humanos': 'briefcase', '/equipamentos': 'equipment', '/veiculos': 'vehicle',
    '/planeamento': 'calendar', '/manutencoes': 'maintenance', '/maquetes': 'layers',
    '/orcamentos': 'briefcase', '/gestao-financeira': 'finance', '/despesas': 'card',
    '/relatorios': 'chart', '/sistema-integrado': 'shield', '/notificacoes': 'bell',
    '/configuracoes': 'settings', '/admin-fichas': 'forms', '/lixeira': 'trash',
    '/utilizadores': 'users', user: 'user', pin: 'pin', menu: 'menu', settings: 'appearance', exit: 'exit'
};
export default function SidebarThemeIcon({ name }) {
    return <AppIcon name={icons[name] || 'user'} size={19} className="sidebar-theme-icon" />;
}
